export default class PbxDomains {
  constructor({
    id = 0,
    customerNumber = 0,
    hostedPbxDomain = '',
    customerEmail = '',
    companyName = '',
    ubDealerId = 0,
    status = '',
  } = {}) {
    this.id = id;
    this.customerNumber = customerNumber;
    this.hostedPbxDomain = hostedPbxDomain;
    this.customerEmail = customerEmail;
    this.companyName = companyName;
    this.ubDealerId = ubDealerId;
    this.status = status;
  }
}
